<div
  class="top-banner"
  *ngIf="showBanner"
  [ngStyle]="{ 'background-image': 'url(' + imageUrl + ')' }"
>
  <div class="layout-boxed top-banner-container">
    <div class="top-banner-title" [innerHtml]="title"></div>
  </div>
</div>
